<template>
  <div class="cat-select2 select-holder">
    <cat-label
      v-if="!labelHandled"
      :label-id="id + '-input-lbl'"
      :label="label"
      :for-id="id"
      :optional="!mandatory"
      :display-optional="showOptionals"
      class="placeholder"
    ></cat-label>
    <span class="dropdown-indicator" tabindex="-1" aria-hidden="true"></span>
    <select
      :id="id"
      v-model="model"
      :aria-required="mandatory"
      :required="errors && errors.length > 0"
      :aria-invalid="errors && errors.length > 0"
      :class="errors && errors.length > 0 ? 'invalidField' : null"
      :disabled="disabled"
      :aria-disabled="disabled ? 'true' : null"
      @change="_onChange"
      @blur="_onBlur"
    >
      <option v-if="placeholder" value>{{ placeholder }}</option>
      <option
        v-for="(item, idx) in items"
        :key="idx"
        :value="item.value"
        :selected="item.value == value ? 'selected' : ''"
      >
        {{ item.text }}
      </option>
    </select>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import jQuery from "jquery";

import SelectMixin from "./select-mixin.js";
import CatLabel from "@/components/utilities/cat-label.vue";
export default defineComponent({
  setup() {
    // Inject the global value
    const showOptionals = inject("showOptionals", true);

    return {
      showOptionals
    };
  },
  name: "CatSelect",
  components: { CatLabel },
  mixins: [SelectMixin],
  props: {
    id: [String],
    errors: [Array],
    label: [String],
    items: [Array],
    hint: [String],
    placeholder: [String],
    value: [String],
    labelHandled: {
      type: Boolean,
      default: false,
      description: "Renders a placeholder label if not handled"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      model: this.value ? this.value : ""
    };
  },
  watch: {
    value: function (newval, oldvalue) {
      if (this.model != newval) {
        if (newval === null || typeof newval === "undefined") {
          this.model = "";
        } else {
          this.model = newval;
        }
      }
    }
  },
  methods: {
    _onBlur: function (event) {
      this.$emit("ui-blur", {
        event: event,
        id: this.id
      });
    }
  }
});
</script>
